/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ClaimInformationDisplayComponent} from './claim-information-display.component';
import {PipesModule} from '../../../shared/pipes/pipes.module';
import {TooltipModule} from '../../../shared/tooltip/tooltip.module';
import {WarningsModule} from '../../../shared/warnings/warnings.module';
import {AttachmentsListDisplayModule} from '../attachments-list-display/attachments-list-display.module';
import {AttachmentsListDisplayErrorModule} from '../attachments-list-display-error/attachments-list-display-error.module';

@NgModule({
    declarations: [ClaimInformationDisplayComponent],
    imports: [
        CommonModule,
        PipesModule,
        TooltipModule,
        WarningsModule,
        AttachmentsListDisplayModule,
        AttachmentsListDisplayErrorModule

    ],
    exports: [ClaimInformationDisplayComponent]
})
export class ClaimInformationDisplayModule {
}
